import React, { useEffect, useRef } from 'react';
import { ParallaxLayer } from '../../../custom_modules/react-spring/src/renderprops/addons/index';
import './JManagedCampaign.scss';
import anime from 'animejs';
import bestInClassIndex from '../assetsV2/managedCampaignIndex';

// 示例图片和数据卡片
const JManagedCampaign = (props) => {
  const {
    pOffset, layoutFactor = 1, offsetAdjust = 0,
  } = props;
  const ref = React.createRef();
  const [activeTab, setActiveTab] = React.useState(0);
  const [pendingTab, setPendingTab] = React.useState(null);
  const cardRef = useRef(null);
  const tabBarRef = useRef(null);
  const tabRefs = useRef([]);
  const indicatorRef = useRef(null);
  // Tab切换动画
  useEffect(() => {
    if (pendingTab !== null && cardRef.current) {
      anime({
        targets: cardRef.current,
        opacity: [1, 0],
        translateX: [0, -40],
        duration: 320,
        easing: 'easeInCubic',
        complete: () => {
          setActiveTab(pendingTab);
          anime.set(cardRef.current, { translateX: 40 });
          anime({
            targets: cardRef.current,
            opacity: [0, 1],
            translateX: [40, 0],
            duration: 360,
            easing: 'easeOutCubic',
            complete: () => setPendingTab(null),
          });
        },
      });
    }
  }, [pendingTab]);

  // 指示条滑动动画
  useEffect(() => {
    if (!tabRefs.current[activeTab] || !indicatorRef.current) return;
    const tabEl = tabRefs.current[activeTab];
    const barEl = tabBarRef.current;
    const indicator = indicatorRef.current;
    const barRect = barEl.getBoundingClientRect();
    const tabRect = tabEl.getBoundingClientRect();
    const left = tabRect.left - barRect.left;
    const width = tabRect.width;
    anime({
      targets: indicator,
      left,
      width,
      duration: 600,
      easing: 'easeOutElastic(1, .7)',
    });
  }, [activeTab]);

  const handleTabClick = (idx) => {
    if (idx !== activeTab && pendingTab === null) {
      setPendingTab(idx);
    }
  };

  return (
    <ParallaxLayer
      offset={pOffset + offsetAdjust}
      factor={layoutFactor}
      speed={0}
      className="jmc-bg-layer "
    >
      {/* 顶部大标题 */}
      <div className="brand-d-noiz-title">
        END-TO-END MANAGED<br />CAMPAIGN PROCESS
      </div>
      {/* Tab导航 */}
      <div className="jmc-tabs" ref={tabBarRef} style={{ position: 'relative' }}>
        {bestInClassIndex.map((item, idx) => (
          <div
            key={item.title}
            className={`jmc-tab${activeTab === idx ? ' active' : ''}`}
            ref={el => tabRefs.current[idx] = el}
            onClick={() => handleTabClick(idx)}
          >
            {item.title.toUpperCase()}
          </div>
        ))}
        <div
          ref={indicatorRef}
          className="jmc-tab-indicator"
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            height: '3px',
            background: '#fa3633',
            borderRadius: '2px',
            transition: 'none',
            zIndex: 3,
            width: 0
          }}
        />
      </div>
      {/* 内容卡片区 */}
      <div className="jmc-card" ref={cardRef}>
        {/* 左侧文字 */}
        <div className="jmc-card-left">
          <div className="jmc-card-title">{bestInClassIndex[activeTab]?.title || ''}</div>
          <div className="jmc-card-desc">
            {bestInClassIndex[activeTab]?.text || ''}
          </div>
        </div>
        {/* 右侧图片/数据卡片 */}
        <div className="jmc-card-right">
          <img src={bestInClassIndex[activeTab]?.image}  className="jmc-tab-image" alt= {bestInClassIndex[activeTab]?.text || ''} loading="lazy" />
        </div>
      </div>
      <div ref={ref} />
    </ParallaxLayer>
  );
};

export default JManagedCampaign;

